import * as types from './mutation-types.js'
import feeds from '@/services/api/feeds'

const state = {
  feed: {}
}

const actions = {
  clearFeed ({commit}) {
    commit(types.CLEAR_FEED)
  },
  async createFeed ({commit}, {path, payload}) {
    let feed = await feeds.updateFeed(path, payload)
    commit(types.SET_FEED, feed)
    return feed
  },
  async deleteFeed ({commit}, path) {
    const result = await feeds.deleteFeed(path)
    commit(types.CLEAR_FEED)
    return result
  },
  async getFeed ({commit}, id) {
    let feed = await feeds.getFeed(id)
    commit(types.SET_FEED, feed)
  },
  async updateFeed ({state, commit}, {payload}) {
    let feed = await feeds.updateFeed(state.feed.update.action, payload)
    commit(types.SET_FEED, feed)
    return feed
  },
  async regenerateAdFreeFeed ({state, commit}) {
    let feed = await feeds.updateFeed(state.feed.regenerate_ad_free.action, {})
    commit(types.SET_FEED, feed)
    return feed
  }
}

const mutations = {
  [types.CLEAR_FEED] (state) {
    state.feed = {}
  },
  [types.SET_FEED] (state, feed) {
    state.feed = feed
  }
}

const getters = {
  feed: state => state.feed
}

export default {
  state,
  actions,
  mutations,
  getters
}
